import React, { useEffect, useState } from 'react';

interface Props { onStart: () => void; }

export const Slide5CTA: React.FC<Props> = ({ onStart }) => {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setPulse(true), 30_000);
    return () => clearTimeout(id);
  }, []);

  return (
    <div className="bs-slide-inner">
      <div className="bs-slide-bg bs-slide-bg--cta" aria-hidden="true">
        <div className="bs-overlay bs-overlay--cta" />
      </div>

      <div className="bs-content bs-content--cta">
        <p className="bs-tagline-line">Some people see borders.</p>
        <p className="bs-tagline-line bs-tagline-line--accent">We see routes.</p>

        <div className="bs-cta-gap" />

        <button
          className={`bs-cta-btn${pulse ? ' bs-cta-btn--pulse' : ''}`}
          onClick={onStart}
        >
          Start Your Journey →
        </button>

        <p className="bs-cta-note">
          Your investor allocation will be confirmed by our team. We'll be in touch.
        </p>
      </div>
    </div>
  );
};
